'use client';

import React from 'react';
import Marquee from 'react-fast-marquee';

const MarqueeComponent = ({ text }) => {
  return (
    <div className='w-full md:w-[65%] overflow-hidden  mx-auto'>
      <Marquee gradient={false} speed={80} pauseOnHover={true}>
        <span className=' text-sm sm:text-md  text-white '>{text}</span>
      </Marquee>
    </div>
  );
};

export default MarqueeComponent;
